import type { BuiltInNoteKind, BuiltInSourceKind, NoteKind, SourceKind } from "../types";
import { statusMeta } from "../lib/lifecycle";

const kindLabels: Record<BuiltInNoteKind | BuiltInSourceKind, string> = {
  article: "Article",
  book: "Book",
  course: "Course",
  critique: "Critique",
  exercise: "Exercise",
  expansion: "Expansion",
  lesson: "Lesson",
  module: "Module",
  note: "Note",
  output: "Output",
  practice: "Practice",
  quote: "Quote",
  reflection: "Reflection",
  task: "Task",
  topic: "Topic",
  youtube: "YouTube"
};

const tone: Record<BuiltInNoteKind | BuiltInSourceKind, string> = {
  article: "border-sky-200 bg-sky-50 text-sky-700",
  book: "border-indigo-200 bg-indigo-50 text-indigo-700",
  course: "border-blue-200 bg-blue-50 text-blue-700",
  critique: "border-rose-200 bg-rose-50 text-rose-700",
  exercise: "border-amber-200 bg-amber-50 text-amber-700",
  expansion: "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700",
  lesson: "border-slate-200 bg-slate-50 text-slate-700",
  module: "border-cyan-200 bg-cyan-50 text-cyan-700",
  note: "border-slate-200 bg-white text-slate-700",
  output: "border-purple-200 bg-purple-50 text-purple-700",
  practice: "border-green-200 bg-green-50 text-green-700",
  quote: "border-violet-200 bg-violet-50 text-violet-700",
  reflection: "border-rose-200 bg-rose-50 text-rose-700",
  task: "border-orange-200 bg-orange-50 text-orange-700",
  topic: "border-teal-200 bg-teal-50 text-teal-700",
  youtube: "border-red-200 bg-red-50 text-red-700"
};

type Props = {
  kind: NoteKind | SourceKind;
};

export function StatusBadge({ kind }: Props) {
  const label = kindLabels[kind as BuiltInNoteKind | BuiltInSourceKind] ?? kind.replace(/_/g, " ");
  const className = tone[kind as BuiltInNoteKind | BuiltInSourceKind] ?? "border-slate-200 bg-slate-50 text-slate-700";

  return (
    <span className={`inline-flex h-6 items-center rounded-md border px-2 text-xs font-semibold ${className}`}>
      {label}
    </span>
  );
}

type LifecycleBadgeProps = {
  kind: NoteKind | SourceKind;
  status?: string;
  className?: string;
};

export function LifecycleBadge({ kind, status, className }: LifecycleBadgeProps) {
  const meta = statusMeta(kind, status);

  return (
    <span
      className={`inline-flex h-6 items-center gap-1 rounded-md border px-2 text-xs font-semibold ${meta.tone} ${className ?? ""}`}
      title={meta.label}
    >
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: meta.dotColor }} />
      {meta.label}
    </span>
  );
}
